import { o_util } from "../../common/namespaces";
import { assignNamespace } from "../../common/assignNamespace.js";
import { runInstrumented, instrument } from "./head/span";
import { initErrorHandling } from "./head/errors.js";

assignNamespace(o_util, "apm", {
  instrument,
  runInstrumented,
  withSpan: instrument,
  runWithSpan: runInstrumented,
});

initErrorHandling();

export { instrument, runInstrumented, instrument as withSpan, runInstrumented as runWithSpan };
